<script>
import Dfes from '@/components/Dfes.vue'
export default {
  components: {
    Dfes
  }
}
</script>

<template>
  <Dfes
    document="nfes"
    descriptionDocument="NFe (s)"
  />
</template>

<style>

</style>
